module.exports = {"question_title":"Wähle eine Sicherheitsfrage","question_description":"Gib im nächsten Bildschirm deine Antwort ein","answer_title":"Antwort auf die Sicherheitsfrage","answer_placeholder":"Gib deine Antwort ein","answer_question":"Deine Antwort auf die Sicherheitsfrage: {{question}}","questions":{"secquestion5":"Der Mädchenname meiner Mutter","secquestion1":"Der Name meines Haustiers","secquestion2":"Mein erstes Auto","secquestion3":"Meine erste Schule"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/securityQuestion.json
// module id = 507
// module chunks = 248 1667